export enum AuthAccess {
  admin,
  owner,
  employee,
  client
}
